<script>
export default {
  data() {
    return {
      showModal: false,
      //   editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
    };
  },
};
</script>

<template>
  <div>
    <div class="sidebar-main-menu">
      <div class="twocolumn-menu-item d-block" id="dashboard">
        <div class="title-box">
          <h5 class="menu-title">Dashboards</h5>
          <ul class="nav flex-column">
            <li class="nav-item">
              <router-link class="nav-link side-nav-link-ref" to="/"
                >Sales</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link side-nav-link-ref"
                to="/dashboard/crm"
                >CRM</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link side-nav-link-ref"
                to="/dashboard/analytics"
                >Analytics</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
